import React from 'react';
import styled from '@emotion/styled';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { fadeTransitions } from './MegaMenu.config';
import { createCSSPropertyTransition } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import LayoutIndexes from '@polestar/component-warehouse-react/tokens/layout-indexes/LayoutIndexes';
import { visuallyHidden } from './MegaMenu.styles';
import { PrimaryAnchorButton } from '@polestar/component-warehouse-react/components/button/Button';
export const MegaMenuSkipToContent = ({ label, ariaLabel, ...props }) => (React.createElement(Anchor, { ...props, icon: undefined, ...aria({ label: ariaLabel }), target: "_self" }, label));
const Anchor = styled(PrimaryAnchorButton) `
  z-index: ${LayoutIndexes.skipToContent};
  position: fixed;
  inset: ${createCustomSpacing(20 / 16)} auto auto ${Spacings.large};
  transition: ${createCSSPropertyTransition('opacity', fadeTransitions)};

  &:not(:focus-within) {
    ${visuallyHidden};
    opacity: 0;
  }
`;
